/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetRandomCoursesNotEnrolledStatus200 } from '../models/GetRandomCoursesNotEnrolled'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getRandomCoursesNotEnrolled } from '../clients/axios/getRandomCoursesNotEnrolled'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRandomCoursesNotEnrolledQueryKey = () => [{ url: '/courses/get-random-courses-not-enrolled' }] as const

type GetRandomCoursesNotEnrolledQueryKey = ReturnType<typeof getRandomCoursesNotEnrolledQueryKey>

export function getRandomCoursesNotEnrolledQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getRandomCoursesNotEnrolledQueryKey()
  return queryOptions<GetRandomCoursesNotEnrolledStatus200, ResponseErrorConfig<Error>, GetRandomCoursesNotEnrolledStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getRandomCoursesNotEnrolled({ ...config, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Random Courses Not Enrolled
 * {@link /courses/get-random-courses-not-enrolled}
 */
export function useGetRandomCoursesNotEnrolled<TData = GetRandomCoursesNotEnrolledStatus200, TQueryData = GetRandomCoursesNotEnrolledStatus200, TQueryKey extends QueryKey = GetRandomCoursesNotEnrolledQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetRandomCoursesNotEnrolledStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getRandomCoursesNotEnrolledQueryKey()

  const queryResult = useQuery({
   ...getRandomCoursesNotEnrolledQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
